// placeholder/placeholderui.js

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import { addListToDropdown, createDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import { ListView, ListItemView, ButtonView, InputTextView } from '@ckeditor/ckeditor5-ui/src';

import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import translations from './lang/translations';

let locale;

export default class PlaceholderUI extends Plugin {
    init() {
        translations();
        const editor = this.editor;
        const t = editor.t;
        const placeholderNames = editor.config.get( 'placeholderConfig.types' );         // CHANGED
        const placeholderLabels = editor.config.get( 'placeholderConfig.labels' );         // CHANGED

        locale = editor.locale;
        
        // The "placeholder" dropdown must be registered among the UI components of the editor
        // to be displayed in the toolbar.
        editor.ui.componentFactory.add( 'placeholder', locale => {
            const dropdownView     = createDropdown( locale );
            const searchInputView  = new InputTextView(locale);
            const placeholderItems = getDropdownItemsDefinitions(placeholderNames, placeholderLabels);
            
            // Create search input
            searchInputView.placeholder = t('Search placeholders...');
            searchInputView.on('input', () => {
                const searchQuery = searchInputView.element.value.toLowerCase();
                // Filter the dropdown items based on search query
                const filteredItems = placeholderItems.filter(item => {
                    return item.model.label.toLowerCase().includes(searchQuery);
                });
                // Repopulate the dropdown with filtered items
                repopulateDropdown(editor, dropdownView, placeholderItems, filteredItems);
            });

            // Add search input and the list of placeholders to the dropdown
            dropdownView.panelView.children.add(searchInputView);
            
            // Populate the list in the dropdown with items.
            addListToDropdown( dropdownView, placeholderItems );
            dropdownView.buttonView.set( {
                // The t() function helps localize the editor. All strings enclosed in t() can be
                // translated and change when the language of the editor changes.
                label: t( 'Placeholder' ),
                tooltip: true,
                withText: true
            } );

            // Disable the placeholder button when the command is disabled.
            const command = editor.commands.get( 'placeholder' );
            dropdownView.bind( 'isEnabled' ).to( command );

            // Execute the command when the dropdown item is clicked (executed).
            this.listenTo( dropdownView, 'execute', evt => {
                editor.execute( 'placeholder', { value: evt.source.commandParam } );
                editor.editing.view.focus();
            } );

            return dropdownView;
        } );
    }
}

function getDropdownItemsDefinitions( placeholderNames, placeholderLabels ) {
    const itemDefinitions = new Collection();

    for (let i = 0; i<placeholderNames.length; i++) {
        const definition = {
            type: 'button',
            model: new Model( {
                commandParam: placeholderNames[i],
                label: placeholderLabels[i],
                withText: true
            } )
        };
        // Add the item definition to the collection.
        itemDefinitions.add( definition );
    }

    return itemDefinitions;
}

// Function to repopulate the dropdown with filtered items.
function repopulateDropdown(editor, dropdownView, placeholderItems, filteredItems) {
    const listView        = dropdownView.panelView.children.find(view => view instanceof ListView);
    const searchInputView = dropdownView.panelView.children.find(view => view instanceof InputTextView);

    listView.items.clear(); // Clear existing items

    for (const item of filteredItems) {
        const listItemView = new ListItemView();
        const buttonView   = new ButtonView(locale);

        buttonView.set({
            label: item.model.label,
            tooltip: true,
            withText: true
        });

        // Listen to the 'execute' event for the button view
        editor.listenTo(buttonView, 'execute', () => {
            editor.execute('placeholder', { value: item.model.commandParam}); // Execute the placeholder command with the item's parameter
            dropdownView.isOpen = false;
            editor.editing.view.focus(); // Ensure the editor remains focused after execution

            // Clear the search field
            searchInputView.element.value = ''; 
            repopulateDropdown(editor, dropdownView, placeholderItems, placeholderItems);
        });

        listItemView.children.add(buttonView);
        listView.items.add(listItemView);
    }
}